import React from 'react';
import { EstablishmentType } from './types';

interface SidebarProps {
  cuisines: string[];
  selectedCuisine: string;
  onSelectCuisine: (cuisine: string) => void;
  establishmentTypes: (EstablishmentType | 'All')[];
  selectedEstablishmentType: EstablishmentType | 'All';
  onSelectEstablishmentType: (type: EstablishmentType | 'All') => void;
  locationSearch: string;
  onLocationSearch: (location: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ 
  cuisines, 
  selectedCuisine, 
  onSelectCuisine,
  establishmentTypes,
  selectedEstablishmentType,
  onSelectEstablishmentType,
  locationSearch,
  onLocationSearch
}) => (
  <aside className="sidebar">
    <h2>Location</h2>
    <input
      type="text"
      value={locationSearch}
      onChange={(e) => onLocationSearch(e.target.value)}
      placeholder="Enter zipcode, city, state, or country"
      className="location-search"
    />
    <h2>Cuisines</h2>
    <ul>
      {cuisines.map(cuisine => (
        <li 
          key={cuisine} 
          className={cuisine === selectedCuisine ? 'active' : ''}
          onClick={() => onSelectCuisine(cuisine)}
        >
          {cuisine}
        </li>
      ))}
    </ul>
    <h2>Establishment Types</h2>
    <ul>
      {establishmentTypes.map(type => (
        <li 
          key={type} 
          className={type === selectedEstablishmentType ? 'active' : ''}
          onClick={() => onSelectEstablishmentType(type)}
        >
          {type}
        </li>
      ))}
    </ul>
  </aside>
);